import React, { useEffect } from "react";
import { FeedbackBox } from "../../components/common/FeedbackBox";
import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { RootState } from "../../store/config/types";
import { connect, ConnectedProps } from "react-redux";
import { urlVarsHelper } from "../../helpers/urlVarsHelper";
import { PaymentStatusEnum } from "../../store/config/enums";
import { isPendingTerminalForResult } from "../../helpers/paymentCallbackState";

const normalizeText = (value?: string | null): string =>
  (value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      display: "flex",
      alignItems: "flex-start",
      minHeight: "100vh",
      height: "100%",
      justifyContent: "center",
      background: '#f0f0f0',
      width: '100%',

      [theme.breakpoints.down('sm')]: {
        padding: 10
      }
    },
  })
);

const mapStateToProps = (state: RootState) => ({
  purchases: state.purchases,
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

function ResultScreen({ purchases }: PropsFromRedux) {
  const classes = useStyles();

  let isCard: boolean = false;
  let errorCode: string;
  let urlVars = urlVarsHelper.getUrlVars();

  if (urlVars.isCard) {
    isCard = urlVars.isCard === "true" ? true : false;
  }

  const purchaseData = purchases?.purchaseData || JSON.parse(sessionStorage.getItem('lastPurchaseData') || 'null');

  useEffect(() => {
    if (!purchases?.purchaseData && purchaseData) {
      sessionStorage.removeItem('lastPurchaseData');
    }
  }, [purchases?.purchaseData, purchaseData]);

  errorCode = decideErrorCode(isCard);

  return (
    <div className={classes.mainContainer}>
      <FeedbackBox
        errorCode={errorCode}
        purchaseData={purchaseData}
        transactionCallbackResponse={purchases.transactionCallbackResponse}
        showActions={true}
      />
    </div>
  );

  function decideErrorCode(isCard: boolean): string {
    const callbackResponse = purchases.transactionCallbackResponse;

    if (!callbackResponse) {
      return isCard ? "3" : "7";
    }

    if (callbackResponse.isBankTransfer === true) {
      return callbackResponse.status === PaymentStatusEnum.ERROR ? "8" : "13";
    }

    if (isPendingTerminalForResult(callbackResponse)) {
      const paymentMethodId = normalizeText(callbackResponse.paymentMethodId);
      return paymentMethodId === "pago-despues" ? "12" : "7";
    }

    if (callbackResponse.status === PaymentStatusEnum.SUCCESS) {
      if (callbackResponse.notACard === false) {
        return "0";
      }

      const paymentMethodId = normalizeText(callbackResponse.paymentMethodId);
      return paymentMethodId === "pago-despues" ? "12" : "7";
    }

    if (callbackResponse.status === PaymentStatusEnum.ERROR) {
      return callbackResponse.notACard ? "8" : "3";
    }

    // Transitional snapshots should not render card success.
    return callbackResponse.notACard ? "7" : "3";
  }
}

export default connector(ResultScreen);
